<template>
  <div style="max-width: 800px; margin: 20px auto; padding: 20px; border: 1px solid #eaeaea; border-radius: 8px;">
    <h3 style="text-align: center;">第五届中国食育膳食技能大赛作品上传</h3>

      <!-- 主视频上传 -->
<!--
      <div class="form-group">
        <label>主视频:</label>
        <input type="file" accept="video/*" @change="handleMainVideoUpload"   style="border: 0px;"/>
        <span>  {{process.video1}} </span>
        <video v-if="formData.mainVideoUrl" :src="formData.mainVideoUrl"   controls style="max-width: 300px;"></video>
      </div>

-->

      <div class="form-group">
        <label for="file-upload" class="custom-file-upload" style="background-color:#19461d">
          <i class="fa fa-cloud-upload"></i> + 上传主视频
        </label>
        <input id="file-upload" type="file" accept="video/*" @change="handleMainVideoUpload"  />
        <span>  {{process.video1}} </span>
        <video v-if="formData.mainVideoUrl" :src="formData.mainVideoUrl"   controls style="max-width: 300px;"></video>

      </div>

      <!-- 预览视频上传 -->
<!--      <div class="form-group">
        <label>预览视频:</label>
        <input type="file" accept="video/*" @change="handlePreviewVideoUpload"   style="border: 0px;" />
        <span>  {{process.video2}} </span>
        <video v-if="formData.previewVideoUrl" :src="formData.previewVideoUrl" controls style="max-width: 300px;"></video>

      </div>-->

      <div class="form-group">
        <label for="file-upload2" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> + 上传预览视频
        </label>
        <input id="file-upload2" type="file" accept="video/*" @change="handlePreviewVideoUpload"  />
        <span>  {{process.video2}} </span>
        <video v-if="formData.previewVideoUrl" :src="formData.previewVideoUrl"   controls style="max-width: 300px;"></video>

      </div>


      <!-- 制作图片上传 -->
      <div class="form-group">

        <label for="file-upload3" class="custom-file-upload"  style="background-color:rgb(179 89 131)">
          <i class="fa fa-cloud-upload"></i> + 上传制作图片
        </label>
        <input  id="file-upload3"  type="file" accept="image/*" @change="handleProcessImageUpload"    style="border: 0px;" />
        <img v-if="formData.processImageUrl" :src="formData.processImageUrl" alt="制作图片预览" style="max-width: 300px;" />
      </div>

      <!-- 成品图片上传 -->
      <div class="form-group">
<!--        <label>成品图片:</label>-->

        <label for="file-upload4" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> + 上传成品图片
        </label>
        <input id="file-upload4" type="file" accept="image/*" @change="handleFinalImageUpload"    style="border: 0px;" />
        <img v-if="formData.finalImageUrl" :src="formData.finalImageUrl"  alt="成品图片预览" style="max-width: 300px;" />
      </div>

      <!-- 备注 -->
      <div class="form-group">
        <label>备注:</label>
        <textarea v-model="formData.remark"  placeholder="请填写备注" rows="4"></textarea>
      </div>


      <!-- 提交按钮 -->
      <button type="button" @click="submitForm" style="margin: auto;text-align: center">提交</button>


  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
import api from "@/api/dsca";
import picApi from "@/api/competitionApplication";
export default {
  data() {
    return {
      file: null,
      file2: null,
      signal:"",
      process:{
        video1:'',
        video2:''
      },
      formData: {
        id: null,
        mainVideoUrl: null,
        previewVideoUrl: null,
        processImageUrl: null,
        finalImageUrl: null,
        remark: ''
      },
    };
  },

  created() {
    //接受传递的参数
    this.formData.id = this.$route.query.id;

    api.sign().then(res => {
      if (res.code === 200) {
        this.signal = res.data;
      }
    });
  },

  methods: {
    // 处理主视频上传
    handleMainVideoUpload(event) {
      this.file= event.target.files[0];
      this.uploadToVod(1);
    },

    // 处理预览视频上传
    handlePreviewVideoUpload(event) {
      this.file2= event.target.files[0];
      if (this.file2) {
        this.uploadToVod(2);
      }
    },

    // 处理制作图片上传
    handleProcessImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        picApi.upload({file:file,watermark:false}).then(res => {
          if (res.code === 200) {
            this.formData.processImageUrl = res.data;
          }
        });
       // this.formData.processImageUrl = URL.createObjectURL(file);
      }
    },

    // 处理成品图片上传
    handleFinalImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        picApi.upload({file:file,watermark:false}).then(res => {
          if (res.code === 200) {
            this.formData.finalImageUrl = res.data;
          }
        })
       // this.formData.finalImageUrl = URL.createObjectURL(file);
      }
    },

    // 表单提交
    submitForm() {
      // 简单前端校验
      const fieldMessages = {
        mainVideoUrl: '主视频',
        previewVideoUrl: '预览视频',
        processImageUrl: '制作图片',
        finalImageUrl: '成品图片'
      };



      for (const field in fieldMessages) {
        console.log("field"+field)
        if (!this.formData[field]) {
          if (field === 'remark'){
          //  console.error('请填写', `${fieldMessages[field]}`);
            alert(`请填写【${fieldMessages[field]}】`);
          }else {
          //  console.error('请上传', `${fieldMessages[field]}`);
            alert(`请上传【${fieldMessages[field]}】`);
          }

          return;
        }
      }

      console.log(this.formData);

      // 发送请求到后端（示例使用 fetch）
      // ...
    },


    getSignature() {
      return this.signal;
    },

    uploadToVod(videoNumber) {
      if (videoNumber===1){
        if (!this.file) {
          alert('请选择一个视频文件');
          return;
        }
      }else {
        if (!this.file2) {
          alert('请选择一个视频文件');
          return;
        }
      }

      const tcVod = new TcVod({ // ✅ 直接 new TcVod
        getSignature: this.getSignature,
      });

      const uploader = tcVod.upload({
        mediaFile: this.file, // ✅ 使用 this.file
        enableResume:  true,

      });

      uploader.on('media_progress', (info) => {
        if (videoNumber===1){
          this.process.video1 ="上传进度:"+ (info.percent * 100).toFixed(2)+"%";
        }
        if (videoNumber===2){
          this.process.video2 ="上传进度:"+ (info.percent * 100).toFixed(2)+"%";
        }
        console.log(`上传进度: ${(info.percent * 100).toFixed(2)}%`);

      });

      uploader.done().then((doneResult) => {
        console.log('上传成功:', doneResult);
       // alert('上传成功');
        if (videoNumber===1){
          this.process.video1 ="上传成功";
          this.formData.mainVideoUrl = doneResult.video.url;
          this.process.video1 ="";
        }
        if (videoNumber===2){
          this.process.video2 ="上传成功";
          this.formData.previewVideoUrl = doneResult.video.url
          this.process.video2 ="";

        }
      }).catch((err) => {
        console.error('上传失败:', err);
       // alert('上传失败');
        if (videoNumber===1){
          this.process.video1 ="上传失败";
          this.file=null;
        }
        if (videoNumber===2){
          this.process.video2 ="上传失败";
          this.file2=null;
        }
      });
    },
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
.form-group input,
.form-group textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px 20px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #337ecc;
}


.signature-actions button {
  margin-right: 10px;
}


.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  background-color: #7089a4;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 12px;
}

.custom-file-upload:hover {
  background: #0b7dda;
}

#file-upload {
  display: none;
}
#file-upload2 {
  display: none;
}
#file-upload3 {
  display: none;
}
#file-upload4 {
  display: none;
}
</style>
